var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerspective30Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    fill: "#00f",
    r: 15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.84 22.95h14.59v1.1h-14.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.18 10.89-3.41-1.69 2.59-5.2 3.41 1.69zm-1.94-2.19 1.44.71 1.61-3.25-1.43-.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.13 4.97.08-1.47 2.42 1.2-1.12.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.83 6.03-.65-.76.55-.46-1.07-.52-.03.71-1-.06.12-2.23 3.78 1.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.67 9.42h1.5v1.46h-1.5z",
    transform: "matrix(.44416612 -.89594445 .89594445 .44416612 -1.08 18.56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.14 23.5 1.61-4.94a1.3 1.3 0 0 1 2.34 0l1.7 4.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.49 24h-7l1.83-5.59a1.94 1.94 0 0 1 1.81-1.08 1.66 1.66 0 0 1 1.46 1zm-5.66-1h4.26l-1.47-4.27a.66.66 0 0 0 -.59-.4.94.94 0 0 0 -.84.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.56 17.02h5.41v1.76h-5.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.62 21.53c-.24 0-.47 0-.71 0a6.68 6.68 0 0 1 -1.64-.41 5.18 5.18 0 0 1 -2.71-2.44 4.82 4.82 0 0 1 -.43-1.11l1.06-.27a3.76 3.76 0 0 0 .34.86 4.08 4.08 0 0 0 2.14 1.93 5.19 5.19 0 0 0 1.33.31 5.31 5.31 0 0 0 5.52-3.32 6.78 6.78 0 0 0 -3.69-8.73l.41-1a7.89 7.89 0 0 1 4.3 10.16 6.4 6.4 0 0 1 -6 4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerspective30Px);
export default __webpack_public_path__ + "static/media/Perspective-30px.bc0bb9818f78342d7067effdc2a26f99.svg";
export { ForwardRef as ReactComponent };